import { useState } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./card"
import RatingIcon from "../../static/media/icons/rating-icon.svg?react"
import { Button } from "./button"
import { CircleDollarSign } from "lucide-react"
import CreditUsage from "./modals/creditusage"

const Credits = () => {
  const [isCreditUsageOpen, setIsCreditUsageOpen] = useState(false)

  const totalCredits = 1100
  const availableCredits = 789
  const percentage = Math.max(0, Math.min(100, Math.round((availableCredits / totalCredits) * 100)))

  return (
    <>
      <Card className="mb-3 p-5">
        <CardHeader className="p-0">
          <CardTitle className="text-xs font-medium text-gray-600">Available Credits</CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          <div className="flex items-center gap-2">
            <RatingIcon className="size-6" /> <span className="text-2xl font-semibold text-gray-950">789</span>{" "}
            <span className="text-xs font-normal text-gray-400">(Total 1100 creds/mo)</span>
          </div>
          {/* progress bar */}
          <div className="mt-3 flex items-center gap-3">
            <div
              className="relative h-3 flex-1 rounded-full bg-gray-200"
              role="progressbar"
              aria-valuenow={percentage}
              aria-valuemin={0}
              aria-valuemax={100}
              aria-label="Available credits percentage"
            >
              <div className="h-3 rounded-full bg-blue-600 transition-[width] duration-500 ease-out" style={{ width: `${percentage}%` }} />
            </div>
            <span className="text-xs font-medium text-gray-600">{percentage}%</span>
          </div>

          <Button
            variant="outline"
            className="mt-3 w-full p-[10px] text-sm font-medium text-gray-600 hover:text-gray-600"
            onClick={() => setIsCreditUsageOpen(true)}
          >
            <CircleDollarSign className="size-5 text-gray-600" /> View credit usage
          </Button>
        </CardContent>
      </Card>

      <CreditUsage open={isCreditUsageOpen} onOpenChange={setIsCreditUsageOpen} />
    </>
  )
}

export default Credits
